import { News } from './news.model';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NewsService } from './news.service';
import { Component, Injector } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent extends BaseListComponent<News> {

  constructor(
    public newServ:NewsService,
    public injector:Injector,
    public auth:AuthService,
    public toastr:ToastrManager,
  ){
    super(newServ, injector, 'news', {editUrl:'/admin/news/edit', createUrl:'/admin/news/new',detailUrl:'/admin/news/detail'});
  }

  // unimplemented method
  protected initChildProprieties(): void {}
  
  
  // unimplemented method
  protected initChildMethods(): void {}

  tableProprieties(): string[] {
    const columns= [
      'Título',
      'Data de Publicação',
      'Nº de Comentários',
      'Clube/Entidade',
      'Estado'
    ];

    if(!this.isAdminOrUserKhuzela()) {
      columns.splice(3,1)
    }

    return columns;
  }

  updateImage(event,news){
    
    if(confirm('Deseja realmente actualizar a Imagem?')){
            // criando um formData
            let formData = new FormData();

            // convertendo o formnews para formData
            for (var key in news) {
              formData.append(key, news[key]);
            }
      
            // Anexando a imagem
            if(event.target.files[0])
              formData.append('photo', event.target.files[0], event.target.files[0].name)

              
      // this.newsServ.updateNews(formData)
      // .subscribe(message=>{
      //   this.toastr.successToastr(message, 'Mensagem', { position: 'top-center' })
      //   this.listOfNews()
      // })
    }
  }

}
